import type { Item, ItemVariant, ItemVariantComposition } from '../models';
import { toBooleanValueFields } from '../transform';
import type { MappedItemResponse } from '../types';
import { generateSearchTokens } from './token';

export const mapItemResponseToModels = (data: MappedItemResponse[]) => {
    const allItems: Item[] = [];
    const allVariants: ItemVariant[] = [];
    const allCompositions: ItemVariantComposition[] = [];

    data.forEach((currentItem) => {
        const { variants: itemVariantsResponse, ...restOfItem } = currentItem;

        const hasValidVariants =
            itemVariantsResponse?.some((variant) => !variant.deleted) ?? false;

        allItems.push(
            toBooleanValueFields(
                {
                    ...restOfItem,
                    nameLower: restOfItem.name.toLowerCase(),
                    searchTokens: generateSearchTokens(restOfItem.name),
                    isActive: restOfItem.isActive && hasValidVariants,
                },
                ['isActive', 'trackItem'],
            ) as unknown as Item,
        );

        itemVariantsResponse?.forEach((currentVariant) => {
            const {
                compositions: variantCompositionsResponse,
                ...restOfVariant
            } = currentVariant;

            allVariants.push({
                ...toBooleanValueFields(restOfVariant, ['deleted']),
                itemId: currentItem.id,
                currentStock: currentVariant.stockDetail?.currentStock,
                lowStockAlert: currentVariant.stockDetail?.lowStockAlert,
                barcodes: restOfVariant.barcode
                    ? restOfVariant.barcode
                          .split(',')
                          .map((barcode) => barcode.trim())
                          .filter(Boolean)
                    : [],
            } as unknown as ItemVariant);

            variantCompositionsResponse?.forEach((currentComposition) => {
                allCompositions.push({
                    ...toBooleanValueFields(currentComposition, ['deleted']),
                    parentVariantId: currentVariant.id,
                } as unknown as ItemVariantComposition);
            });
        });
    });

    return {
        items: allItems,
        itemVariants: allVariants,
        itemVariantCompositions: allCompositions,
    };
};
